import { render, staticRenderFns } from "./UserListAddNew.vue?vue&type=template&id=54cd6fb2"
import script from "./UserListAddNew.vue?vue&type=script&lang=js"
export * from "./UserListAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports